//#region IMPORT
import { Dialog, Transition } from "@headlessui/react";
import { useAppDispatch } from "../../store/configureStore";
import { closeMobileDash } from "../../features/dashBoard/dashboardSlice";
import { XMarkIcon } from "@heroicons/react/24/outline";
import DashboardSidebarList from "./DashboardSidebarList";
//#endregion

interface Props {
  mobileDashOpen: boolean;
}

export default function DashboardSidebarMobile({ mobileDashOpen }: Props) {
  //#region SETUP
  // Redux
  const dispatch = useAppDispatch();
  //#endregion

  //#region RENDER
  return (
    <Transition show={mobileDashOpen}>
      <Dialog
        className="relative z-40 2xl:hidden"
        onClose={() => dispatch(closeMobileDash())}
      >
        <Transition
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-900/80" />
        </Transition>

        <div className="fixed inset-0 flex">
          <Transition.Child
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
              <Transition.Child
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                  <button
                    type="button"
                    className="-m-2.5 p-2.5"
                    onClick={() => dispatch(closeMobileDash())}
                  >
                    <XMarkIcon
                      className="h-6 w-6 text-white"
                      aria-hidden="true"
                    />
                  </button>
                </div>
              </Transition.Child>

              {/* Mobile Sidebar */}
              <div className="flex grow flex-col gap-y-12 overflow-y-auto bg-white px-6 pb-4 pt-6 h-screen">
                <DashboardSidebarList dashOpen={mobileDashOpen} />
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
  //#endregion
}
